import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebase-config";

export const GLOBAL_UPI_VERIFY_COLLECTIONS = [
  "global-upi-verify-records",
  "global-upi-records",
  "upi-global-records",
  "upi-records",
];

export const normalizeGlobalUpiId = (value = "") =>
  String(value).trim().toLowerCase().replace(/\s+/g, "");

const extractUpiValue = (data = {}) => {
  const directValue =
    data.upi ||
    data.upiId ||
    data.vpa ||
    data.upi_id ||
    data.virtualPaymentAddress ||
    data.paymentAddress ||
    data.qrPayload ||
    data.upiLink ||
    "";

  const normalized = String(directValue || "").trim();
  if (!normalized) return "";

  if (!normalized.toLowerCase().startsWith("upi://")) {
    return normalized;
  }

  try {
    const url = new URL(normalized);
    return url.searchParams.get("pa") || "";
  } catch (_error) {
    return normalized;
  }
};

const extractNameValue = (data = {}) =>
  data.name ||
  data.payeeName ||
  data.accountHolderName ||
  data.customerName ||
  data.savedName ||
  data.fullName ||
  "";

export const fetchGlobalUpiVerifyRecords = async () => {
  let records = [];

  for (const collectionName of GLOBAL_UPI_VERIFY_COLLECTIONS) {
    const snapshot = await getDocs(collection(db, collectionName));
    const currentRecords = snapshot.docs
      .map((item) => {
        const data = item.data() || {};
        const upiValue = extractUpiValue(data);
        const nameValue = extractNameValue(data);

        return {
          id: item.id,
          ...data,
          upi: upiValue,
          name: nameValue,
          sourceCollection: collectionName,
          normalizedUpi: normalizeGlobalUpiId(upiValue),
        };
      })
      .filter((item) => item.normalizedUpi);

    if (currentRecords.length) {
      records = currentRecords;
      break;
    }
  }

  return records.sort((a, b) =>
    String(b.createdAt || b.updatedAt || "").localeCompare(String(a.createdAt || a.updatedAt || ""))
  );
};
